import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ApprovalGroupService } from "../../approval-groups/service/approval.group.service";
import { DropDownItem } from "../../../pojo/DropDownItem";

@TypeManagerDecorator("s25-approval-group-dropdown")
@Component({
    selector: "s25-approval-group-dropdown",
    template: `
        @if (this.items) {
            <s25-generic-dropdown
                [(chosen)]="this.chosen"
                [hasFav]="false"
                [onSelect]="this.onSelect"
                [items]="this.items"
                [staticItems]="this.staticItems"
                [autoOpen]="this.autoOpen"
                [alwaysOpen]="this.alwaysOpen"
                [hideSearch]="this.hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [placeholder]="'Select an Approval Group'"
                [resetSelectedOnCleanup]="this.resetSelectedOnCleanup"
                [hasNoneItem]="this.hasNoneItem"
                [noneItemLabel]="this.noneItemLabel"
                (chosenChange)="onChosenChange($event)"
            >
            </s25-generic-dropdown>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class S25ApprovalGroupDropdownComponent extends S25DropdownAbstract implements OnInit {
    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    async ngOnInit() {
        try {
            // Load approval groups and convert to DropDownItem format
            const approvalGroups = await ApprovalGroupService.getApprovalGroups();
            this.items = approvalGroups.map(
                (group) =>
                    ({
                        itemId: group.approvalGroupId!,
                        itemName: group.name,
                        itemTypeId: undefined, // Approval groups don't have a specific type ID
                    }) as DropDownItem,
            );

            // Sort by name
            this.items.sort((a, b) => (a.itemName || "").localeCompare(b.itemName || ""));

            // If we have a chosen value but it's not in the items (e.g., placeholder),
            // find the matching item and update the chosen value
            if (this.chosen && this.chosen.itemId) {
                const matchingItem = this.items.find((item) => item.itemId === this.chosen!.itemId);
                if (matchingItem) {
                    this.chosen = matchingItem;
                }
            }

            this.cd.detectChanges();
        } catch (error) {
            console.error("Error loading approval groups:", error);
            this.items = [];
            this.cd.detectChanges();
        }
    }
}
